import Word from '@puzzleapps/shared/src/store/models/Word'

const state = {
  words: [],
  title: '', 
  solution: '', 
  letterHintMode: false,
  // selected: {
  //   down: null,
  //   across: null,
  // }
}

// TODO: it might be much more efficient to organise the clues by using their
// clue number as a key index 
const getters = {
  convertForLocal: state => {
    let data = []
    state.words.map(word => data.push({word: word.word, found: word.found }))
    return data
  },

  remainingWords: state => {
    let found = state.words.filter((x,i) => { return x.found; }).length
    return state.words.length - found
  },

  sortedWords: state => {
    return state.words.sort((a,b) => {
      return (+a.found) - (+b.found) || a.word.localeCompare(b.word)
    })
  },

}

// { direction:string, clueNumber:number, clue:string }
const actions = {
  
  setWords({ commit, rootGetters }, words) {
    
    commit('CLEAR_WORDS')

    words.map(row => {      
      let word = new Word()
      word.row = row.r
      word.col = row.c
      word.word = row.w
      word.direction = row.d

      let wordLength = word.word.replace(/[^A-Za-z]/g, '') // remove spaces, apostophes etc
      wordLength = wordLength.split('')
      wordLength = wordLength.length - 1

      let endCellRow = word.row
      let endCellCol = word.col

      let north = word.direction === 0 || 
                  word.direction === 1 ||
                  word.direction === 7

      let east  = word.direction === 1 || 
                  word.direction === 2 ||
                  word.direction === 3

      let south = word.direction === 3 || 
                  word.direction === 4 ||
                  word.direction === 5

      let west  = word.direction === 5 || 
                  word.direction === 6 ||
                  word.direction === 7

      if (north) endCellRow -= wordLength
      if (east)  endCellCol += wordLength
      if (south) endCellRow += wordLength
      if (west)  endCellCol -= wordLength

      word.startCell = rootGetters['grid/getCellAtPosition'](word.row, word.col)
      word.endCell   = rootGetters['grid/getCellAtPosition'](endCellRow, endCellCol)

      commit('PUSH_WORD', word)

    })
  },

  clearAllInputs({ state }) {
    state.words.map(word => {
      word.found = false
    })
  },

  setInputsFromLocal({ state, commit }, local) {
    if (local && local.words) {
      state.words.map(word => {
        let matching = local.words.find(lWord => lWord.word === word.word)
        if (matching)
          word.found = matching.found
      })
    }
  },

  // cellsPos = [startCell, endCell]
  setWordFound({ commit, state, dispatch }, cellsPos) {

    let word = state.words.find(word => 
      cellsPos[0] === word.startCell && 
      cellsPos[1] === word.endCell
    )

    // also allow the reverse of the owrd to be selected
    let reverseword = state.words.find(word => 
      cellsPos[1] === word.startCell && 
      cellsPos[0] === word.endCell
    )

    if (!word){
      if(!reverseword)
      {
        return
      }
      else
      {
        commit('SET_FOUND', reverseword)
      }
    } 
    else{
      commit('SET_FOUND', word)
    }


    
    dispatch('checkWordsearchCompleted')
  },

  hint({ state, dispatch }) {
    let unFound = state.words.filter(word => !word.found)
    let randIndex = Math.floor(Math.random() * unFound.length)
    let word = unFound[randIndex]

    dispatch('setWordFound', [word.startCell, word.endCell])
  },

  letterHint({ commit }, status){
    commit('SET_LETTER_HINT_MODE', status)
  },

  checkWordsearchCompleted({ dispatch }) {
    for (let i in state.words) {
      let word = state.words[i]
      if (!word.found) {
        dispatch('game/setCompleted', false, { root: true })
        return 
      }
    }
    // if all cells are correct finish game
    
    dispatch('game/setCompleted', true, { root: true })
    dispatch('game/saveToLocal', true, { root: true })
    dispatch('game/recordFinish', true, { root: true })
    dispatch('game/finishGame', true, { root: true })
  },
 
  setTitle({ commit }, title) {
    commit('SET_TITLE', title)
  },
  
  setSolution({ commit }, title) {
    commit('SET_SOLUTION', title)
  },
  
  clearState({ commit }) {
    commit('CLEAR_WORDS')
    commit('SET_TITLE', '')
    commit('SET_SOLUTION', '')
  },
  
}

const mutations = {

  CLEAR_WORDS(state) {
    state.words = []
  },

  SET_TITLE(state, title) {
    state.title = title
  },
  
  SET_SOLUTION(state, solution) {
    state.solution = solution
  },

  // word model
  PUSH_WORD(state, word) {
    state.words.push(word)
  },

  SET_FOUND(state, word) {
    word.found = true
  },

  SET_LETTER_HINT_MODE(state, status){
    state.letterHintMode = status
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}